<template>
    <v-row justify="center">
        <v-dialog
            :value="value"
            persistent
            max-width="560"
        >
        <v-card>
            <v-card-title class="text-h5">
                Sort & Filter
            </v-card-title>
            <v-card-text
                class="mt-5"
            >
                <v-row>
                    <v-col
                        cols="6"
                    >
                        <v-select
                          :items="sorts"
                          v-model="selected_sort"
                          placeholder="Sort By"
                          item-text="name"
                          item-value="value"
                        >
                          <template v-slot:append>
                            <v-icon color="blue" class="mt-1" style="margin-left:-15px;">mdi-chevron-down</v-icon>
                          </template>
                        </v-select>
                        <v-select
                          :items="asc_desc"
                          v-model="selected_asc_desc"
                          placeholder="Order"
                          item-text="name"
                          item-value="value"
                        >
                          <template v-slot:append>
                            <v-icon color="blue" class="mt-1" style="margin-left:-15px;">mdi-chevron-down</v-icon>
                          </template>
                        </v-select>
                    </v-col>
                    <v-col
                        cols="6"
                    >
                        <v-select
                          chips
                          :items="get_features"
                          v-model="selected_status"
                          placeholder="Filter By"
                          item-text="name"
                          item-value="name"
                        >
                          <template v-slot:append>
                            <v-icon color="blue" class="mt-1" style="margin-left:-15px;">mdi-chevron-down</v-icon>
                          </template>
                          <template #selection="{ item }">
                            <v-chip
                                style="color:white;width:90%;cursor: pointer;"
                                :class="(item.id == 1) ? 'status_1' :
                                        (item.id == 2) ? 'status_2' : 'status_0'"
                            >
                              <strong style="font-size:12px;">{{ item.name }}</strong>
                            </v-chip>
                          </template>
                        </v-select>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
                v-if="selected_sort != null || selected_asc_desc != null || selected_status != null"
                color="green darken-1"
                text
                @click="clear_all"
            >
                Clear all
            </v-btn>
            <v-btn
                color="green darken-1"
                text
                @click="cancel_dialog_sort_filter"
            >
                Cancel
            </v-btn>
            <v-btn
                color="#1976D2"
                dark
                class="pl-10 pr-10"
                @click="apply_sort_filter"
            >
                <v-icon
                    class="mr-2"
                >mdi-check</v-icon>
                Apply
            </v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
    </v-row>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  components: {
  },
  props: [
    'value'
  ],
  data: () => ({
    sorts: [ 
        {
            name: 'Client',
            value: 'name' 
        },
        {
            name: 'Last login',
            value: 'updated_at'
        },
        
     ],
    asc_desc: [ 
        {
            name: 'Ascending',
            value: false
        },
        {
            name: 'Descending',
            value: true
        },
        
     ],
    selected_sort: null,
    selected_asc_desc: null,
    selected_status: null,
  }),
  mounted () {
  },
  created () {
  },
  computed: {
    ...mapGetters({
        get_status:             'fd_client/get_status',
        fd_data:                'auth/get_user',
        get_features:           "client/get_features",
    })
  },
  methods: {
    showSnackBar(message){
        this.$store.commit("auth/setMessage", 
        {show: true, message: message}, 
        {root: 1})
    },
    cancel_dialog_sort_filter(){
        this.$emit('cancel_dialog_sort_filter')
    },
    async apply_sort_filter(){
        let payload = {
            sort_by: this.selected_sort,
            asc_desc: this.selected_asc_desc,
            filter_by: this.selected_status
        }
        this.$emit('apply_sort_filter', payload)
      },
    clear_all(){
        this.$emit('clear_all')
        this.selected_sort = null
        this.selected_asc_desc = null
        this.selected_status = null
    }
  },
  watch: {
  }
}
</script>

<style scoped lang="scss">
::v-deep .v-input__control>.v-input__slot:before, ::v-deep .v-input__control>.v-input__slot:after {
  border-style:none!important;
}
.status_0, .status_1, .status_2 { justify-content: center; }
.status_1 { background-color:#FAFAFA!important;color:#172C54!important; }
.status_2 { background-color:#4786FF!important;color:#FFF!important; }
</style>